module.exports = __webpack_public_path__ + "img/Menu-08.362ce29e.png";